import React, { useContext, useEffect, useState } from 'react'

const AccordDiv = (props) => {

    const [divName, setDivName] = useState(props.DivName);

    useEffect(() => {
        setDivName(props.DivName);
    }, [props.DivName])
    

    return (
        <div className={"prodFirst"}><label>שם המחלקה</label>
            <input type="text" value={divName} placeholder={"שם המחלקה"}
                onBlur={(e) => props.changeDivName(props.index, e.target.value)}
                onChange={(e) => setDivName(e.target.value)} />
        </div>
    )
}

export default AccordDiv;